module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery3.d8ced58a5efaa3215a2d33750ae461b9.png";